<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
}
div,
a,
p,
span,
h1 {
  box-sizing: border-box;
}
.detail-main {
  p,
  img,
  video,
  div,
  span {
    max-width: 100%;
  }
}
.box-1 {
  p,
  img,
  div,
  table,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  span,
  video {
    max-width: 100% !important;
  }
}
.flex {
  display: flex;
}
.flex_wrap {
  display: flex;
  flex-wrap: wrap;
}
.flex_center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex_end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.flex_start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flex_sw {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pd-90 {
  padding-top: 0.469rem;
}
/* 弹窗 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
  justify-content: center;
  align-items: center;
}

.mask-main {
  width: 60vw;
  text-align: center;
  background-color: #000;
  /* padding: 10px 0 20px; */
}

.mask-close {
  color: #fff;
  text-align: right;
  padding: 10px 2% 0 0;
  font-size: 1.5625vw;
  cursor: pointer;
}

.mask-video {
  width: 100%;
}

.mask-video video {
  width: 100%;
}
.hide-one {
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */
}
.hide-two {
  display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  -webkit-line-clamp: 2; /* 限制显示两行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */
}
.hide-two-1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.about_nav {
  height: 0.417rem;
  background-color: #ffffff;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.37rem;
  .about_nav_left {
    display: flex;
    align-items: center;

    .anl_item {
      height: 0.417rem;
      position: relative;
      line-height: 0.417rem;
      color: #333;
      font-size: 0.083rem;
      margin-right: 0.271rem;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &::after {
        display: block;
        content: "";
        position: absolute;
        bottom: 0;
        height: 2px;
        background: #e5322d;
        width: 0%;
        transition: all 0.5s;
        left: 50%;
        transform: translateX(-50%);
      }
      &:hover {
        color: #e5322d;
        &::after {
          width: 100%;
        }
      }
    }
    .anl_item_active {
      color: #e5322d;
      &::after {
        width: 100%;
      }
    }
  }
  .about_nav_right {
    display: flex;
    align-items: center;
    img {
      cursor: pointer;
    }
    .about_nav_right_item {
      display: flex;
      align-items: center;
      color: #333;
      i {
        font-size: 0.052rem;
        margin: 0 0.078rem;
      }
    }
    .about_nav_right_item_active {
      color: #e5322d;
    }
  }
}
.pagination {
  margin-top: 0.417rem;
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #e5322d;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #e5322d;
    color: #fff;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 0.219rem;
    height: 0.219rem;
    line-height: 0.219rem;
    font-size: 0.073rem;
    background-color: #fff;
    border: solid 1px #dfe0e0;
  }
}
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  // display: none;
  align-items: center;
  justify-content: center;
}
.mask-honor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // width: 8.531rem;
  cursor: pointer;
  z-index: 10000;
}
.mask-honor-icon {
  width: 0.365rem;
  height: 0.365rem;
  background-color: #666666;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.mask-honor-pre {
  left: 1.042rem;
}
.mask-honor-next {
  right: 1.042rem;
}
.mask-honor-img {
  width: 5.333rem;
}
.mask-honor-img img {
  width: 100%;
  display: block;
  max-height: 90vh;
}
.mask-honor i {
  font-size: 0.089rem;
  color: #fff;
}
.mask-honor-icon:hover {
  background-color: #e5322d;
}
.layui-nav-tree .layui-nav-item > a .layui-nav-more {
  padding: 0;
}
.h5_nav {
  display: none;
}
@media (max-width: 680px) {
  .pd-90 {
    padding-top: 64px;
  }
  .h5_nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px;
    height: 60px;
    border-bottom: 1px solid #d1d1d1;
    .el-select {
      width: 100%;
    }
  }
  .el-range-editor.is-active,
  .el-range-editor.is-active:hover,
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #e5322d;
  }
  .el-select-dropdown__item.selected {
    color: #e5322d;
  }
  .about_nav {
    display: none;
  }
  .pagination {
    margin-top: 50px;
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #e5322d;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #e5322d;
      color: #fff;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      min-width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      background-color: #fff;
      border: solid 1px #dfe0e0;
    }
  }
  .mask-honor {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 8.531rem;
    cursor: pointer;
    z-index: 10000;
  }
  .mask-honor-icon {
    width: 40px;
    height: 40px;
    background-color: #666666;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
  }
  .mask-honor-pre {
    left: 10px;
  }
  .mask-honor-next {
    right: 10px;
  }
  .mask-honor-img {
    width: 80%;
  }
  .mask-honor-img img {
    width: 100%;
    display: block;
    max-height: 90vh;
  }
  .mask-honor i {
    font-size: 14px;
    color: #fff;
  }
}
</style>
